export const isValidPhone = (phone) => {
    if (!phone) return false;

    // Казахстан
    if (phone.startsWith('+7')) {
        return phone.length === 12;
    }

    // Кыргызстан
    if (phone.startsWith('+996')) {
        return phone.length === 13;
    }

    return false;
};